import { render, staticRenderFns } from "./ItemsSearchDialog.vue?vue&type=template&id=6e342e1c&"
import script from "./ItemsSearchDialog.vue?vue&type=script&lang=js&"
export * from "./ItemsSearchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QBtn} from 'quasar'
component.options.components = Object.assign({QDialog,QBtn}, component.options.components || {})
